// extracted by mini-css-extract-plugin
export default {"txt-field":"text-field_txt-field__uzsB1","multiline-field":"text-field_multiline-field__8Sw2m"};